import * as actions from '../utils/Constants';
import { apiGet, apiDeleteWithBodyAndThen } from '../utils/Api';

const apiProject = `${process.env.REACT_APP_API_HOST}api/project/`;
const apiProjects = `${process.env.REACT_APP_API_HOST}api/projects`;

const getProjectsApi = () =>
    fetch(apiProjects, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        credentials: 'include',
    }).then(res => {
        return res.json();
    });


export const getProjects = () => {
    return {
        type: actions.GET_PROJECTS,
        payload: getProjectsApi()
    }
}

export const getProject = (id) => {
    return {
        type: actions.GET_PROJECT,
        payload: fetch(apiProject + id, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        }).then(res => {
            return res.json();
        })
    }
}

export const deleteProjects = (ids = []) => ({
    type: actions.DELETE_PROJECT,
    payload: apiDeleteWithBodyAndThen(apiProjects, ids, () => apiGet(apiProjects))
});

export const newProject = () => ({type: actions.NEW_PROJECT})
